import type { Loading } from "@/lib/loading"
import { dependenciesReady } from "@/lib/loading/dependenciesReady"
import { processIsReady } from "@/lib/loading/processIsReady"

export const shouldComponentReady = (
  nextProps: { loading: Loading.ContextData },
  nextState: { loadingConfig: Loading.Config }
) => {
  if (nextState.loadingConfig.readying) {
    return false
  }

  if (processIsReady(nextProps, nextState.loadingConfig.processId)) {
    return false
  }

  return dependenciesReady(nextProps, nextState.loadingConfig)
}
